import React from "react";
import ReportsActionsTable from "../../components/ReportsActionsTable";
import ReportsInterviewsTable from "../../components/ReportsInterviewsTable";
import ReportsEvaluationTeamTable from "../../components/ReportsEvaluationTeamTable";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { draftData } from "../ReportEditor/staticReportData";

const ReportsAppendix = () => {
    const [t] = useTranslation();
    const reportData = useSelector((state:any) => state.evaluation.reportData);
    // const reportData = draftData;
    const actionData = reportData?.Criteria.flatMap((c:any) =>
        c?.Standards?.flatMap((s:any) => s?.Actions)
    );
    return(
        <Box className={'a4Spacing mb20'}>
            <Typography className="fw700 fs24 uppercase textAlignLeft">{t('APPENDIX')}</Typography>
            <Typography className="fw700 fs18 uppercase textAlignLeft">{t('ACTIONS')}</Typography>
            <ReportsActionsTable data={actionData} />
            <Typography className="fw700 fs18 uppercase textAlignLeft">{t('INTERVIEWS')}</Typography>
            <ReportsInterviewsTable data={reportData?.Sessions} />
            <Typography className="fw700 fs18 uppercase textAlignLeft">{t('EVALUATION_TEAM')}</Typography>
            <ReportsEvaluationTeamTable data={reportData?.EvaluationTeam} />
        </Box>
    )
}

export default ReportsAppendix;